import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../redux/axios';

const initialState = {
    NotifyData: [],
    isFetching: false,
    isNotifySuccess: false,
    isResendNotySucess: false,
    isError: false,
    errorMessage: '',
    imagePath: '',
};

export const getAllNotification = createAsyncThunk(
    '/notification/allNotifications?type=',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            let response = await axios({
                url: `/api/notification/allNotifications?type=${udata}`,
                method: 'get',
                headers: {
                    "Authorization": `Bearer ${tokenStr}`
                }
            })

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (data.code === 200) {
                return data;
            }
            else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(err.response.data)
        }
    }
);

export const resendNotification = createAsyncThunk(
    'notification/resend',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            const response = await axios.post('/api/notification/resend', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

            let data = response.data;

            if (response.status === 200) {
                return data;
            }
            else if (response.status === 201) {
                return data;
            } else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(err.response.data)
        }
    }
);



export const DDsAndAdsViewAllNotificationSlice = createSlice({
    name: 'DDsAndAdsviewallnotification',
    initialState,
    reducers: {
        DDsAndAdsClearStateAllNotification: (state, { payload }) => {
            state.NotifyData = [];
            state.isFetching = false;
            state.isNotifySuccess = false;
            state.isResendNotySucess = false;
            state.isError = false;
            state.errorMessage = '';
            state.imagePath = '';
        },
        DDsAndAdsClearStateResendNotification: (state, { payload }) => {
            state.isResendNotySucess = false;
            state.isError = false;
            state.errorMessage = '';
            state.isFetching = false;
        },
    },

    extraReducers: {
        [getAllNotification.fulfilled]: (state, { payload }) => {
            state.NotifyData = payload.data.data;
            state.imagePath = payload.data.imagePath;
            state.isFetching = false;
            state.isNotifySuccess = true;
            return state;
        },
        [getAllNotification.pending]: (state) => {
            state.isFetching = true;
        },
        [getAllNotification.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        },
        [resendNotification.fulfilled]: (state, { payload }) => {

            if (payload.success == false) state.isError = true;
            else state.isError = false;
            if (payload.success) state.isResendNotySucess = true;
            if (payload.message) state.errorMessage = payload.message;
            else state.errorMessage = '';

            return state;
        },
        [resendNotification.pending]: (state) => {
            state.isFetching = true;
        },
        [resendNotification.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        }

    },
});

export const { DDsAndAdsClearStateAllNotification, DDsAndAdsClearStateResendNotification } = DDsAndAdsViewAllNotificationSlice.actions;

export function clearState() {

    return async (dispatch) => {
        dispatch(DDsAndAdsClearStateAllNotification());
    }
}

export function clearStateResendNotify() {

    return async (dispatch) => {
        dispatch(DDsAndAdsClearStateResendNotification());
    }
}



export const takeActionChildProcessAsyn = (pdata) => async (dispatch, getState) => {
    try {
        const { auth } = getState()
        let tokenStr = auth.user.token;
        let userType = auth.user.userType == 'CHD' ? 'chd' : auth.user.userType == "DD's & AD's" ? 'DDsAndAds' : 'clerk';
        let response = await axios({
            url: `/api/${userType}/v2/document/detailed?processId=${pdata}`,
            method: 'get',
            headers: {
                "Authorization": `Bearer ${tokenStr}`
            }
        })

        let data = response.data;
        return data;
    } catch (error) {
        return error.response.data;
    }
};




export const DDsAndAdsViewProcessSelector = (state) => state.DDsAndAdsviewallnotification;

export default DDsAndAdsViewAllNotificationSlice.reducer;
